<template>
  <div>
    <carbonfootprint-wapper title="供应商基本信息">
      <!-- <div class="supplier-info">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="supplier-info-item">
              <div class="supplier-info-item-label">供应商名称：</div>
              <div class="supplier-info-item-value">
                {{ userInfo.companyName }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div> -->
      <el-form
        ref="contactForm"
        :model="contactForm"
        label-width="130px"
        label-suffix=":"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item class="cursor-form-item" label="供应商名称">
              <span>{{ userInfo.companyName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="cursor-form-item" label="填报信息联系人">
              <el-input
                v-model="contactForm.contactName"
                :disabled="isReadonly"
                placeholder="请输入填报信息联系人"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="填报信息联系电话" class="cursor-form-item">
              <el-input
                v-model="contactForm.contactPhone"
                :disabled="isReadonly"
                placeholder="请输入填报信息联系电话"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </carbonfootprint-wapper>
    <tip style="margin-bottom: 10px" />
    <!-- <carbonfootprint-wapper title="上传类型">
      <template #title>
        <div>
          <span class="required">*</span>
          上传类型
        </div>
      </template>
      <div class="flex gap-5">
        <div class="flex items-center gap-1">
          <el-checkbox-group v-model="checkList" @change="handleChangeCheckList">
            <el-checkbox v-for="item in options" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </carbonfootprint-wapper> -->
    <carbonfootprint-wapper title="产品碳足迹">
      <product-carbon-footprint
        ref="productCarbonFootprint"
        :key="draftReloadKey"
        :report="carbonReportList"
        :readonly="isReadonly"
        :structure-locked="isListRecordEdit"
      />
    </carbonfootprint-wapper>
    <div class="footer-btn">
      <eui-btn
        type="secondary"
        width="120"
        size="44"
        font-size="14px"
        @click="handleClose"
        >返回</eui-btn
      >
      <eui-btn
        v-if="$route.query.type !== 'detail'"
        type="weak"
        width="120"
        size="44"
        font-size="14px"
        @click="handleSave"
      >
        保存
      </eui-btn>
      <eui-btn
        v-if="showSubmitBtn"
        width="120"
        size="44"
        font-size="14px"
        @click="handleSubmit"
      >
        提交
      </eui-btn>
    </div>
    <div class="contactUs">
      <div class="left"></div>
      <!-- <div class="center">
        <div class="item">
          <span class="name">
            <eui-icon
              icon="eicon-r-yonghu"
              font-size="16px"
              color="#0064C8"
              class="itemIcon"
            ></eui-icon>
            高经理
          </span>
          <span class="phone">
            <eui-icon
              icon="eicon-r-dianhua"
              font-size="16px"
              color="#0064C8"
              class="itemIcon"
            ></eui-icon>
            010-62329096
          </span>
        </div>
        <div class="item">
          <span class="name">
            <eui-icon icon="eicon-r-yonghu" font-size="16px" color="#0064C8" class="itemIcon"></eui-icon>
            刘经理
          </span>
          <span class="phone">
            <eui-icon icon="eicon-r-dianhua" font-size="16px" color="#0064C8" class="itemIcon"></eui-icon>
            010-21532415
          </span>
        </div>
      </div> -->
      <div class="center">
        <div class="item">
          <span class="name">
            <eui-icon
              icon="eicon-r-yonghu"
              font-size="16px"
              color="#0064C8"
              class="itemIcon"
            ></eui-icon>
            刘经理
          </span>
          <span class="phone">
            <eui-icon
              icon="eicon-r-dianhua"
              font-size="16px"
              color="#0064C8"
              class="itemIcon"
            ></eui-icon>
            010-21532415
          </span>
        </div>
      </div>

      <!-- <div class="right"></div> -->
    </div>
    <EDialog
      :center-dialog-visible="submitVisible"
      dialog-type="other"
      :dialog-title="'提交报告'"
      @resetPopupData="resetPopupData"
      @submitPopupData="handleSubmitData"
    >
      <div>确认您填报的内容数据真实和有效！</div>
      <div class="opera">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="0"
          class="demo-ruleForm"
        >
          <el-form-item prop="isAgree">
            <!-- {{ ruleForm.isAgree }} -->
            <el-checkbox
              v-model="ruleForm.isAgree"
              :true-label="'1'"
              :false-label="''"
            ></el-checkbox>
            <span class="agreeTxt">
              我已阅读并同意
              <eui-btn type="text" @click="toAgreement"
                >《绿色低碳信息提供告知同意书》</eui-btn
              >
            </span>
          </el-form-item>
        </el-form>
      </div>
    </EDialog>
    <CarbonFootprintAgreeDialog
      :agree-visible="agreeVisible"
      @change="agreeVisible = false"
    ></CarbonFootprintAgreeDialog>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/carbonfoot';
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import CarbonfootprintWapper from './components/carbonfootprintWapper.vue';
import ProductCarbonFootprint from './components/productCarbonFootprint.vue';
import Tip from './components/tip.vue';
import CarbonFootprintAgreeDialog from './components/CarbonFootprintAgreeDialog.vue';

function resolveTabRef(refs, refName) {
  const target = refs[refName];
  if (!target) {
    return null;
  }
  return Array.isArray(target) ? target[0] : target;
}

const decodeMask = (S) => {
  const values = [2, 4, 8, 16, 32, 64];
  const n = Number(S);
  /* eslint-disable-next-line no-bitwise -- dataType 位掩码解析 */
  return values.filter((v) => (n & v) !== 0);
};

/** 证书位 2 + 产品碳足迹报告位 4，接口示例 dataType 为 6 */
const LEGACY_CERT_MASK = 2;
const PRODUCT_CARBON_REPORT_MASK = 4;

const normalizeMergedProductDataTypes = (types) => {
  const hadCertOrReport =
    types.includes(LEGACY_CERT_MASK) ||
    types.includes(PRODUCT_CARBON_REPORT_MASK);
  const next = types.filter((v) => v !== LEGACY_CERT_MASK);
  if (hadCertOrReport && !next.includes(PRODUCT_CARBON_REPORT_MASK)) {
    next.push(PRODUCT_CARBON_REPORT_MASK);
  }
  return next.sort((a, b) => a - b);
};

/** 每次进入页面使用的默认空结构；接口无草稿或失败时仍用此结构展示 */
const getEmptyInitPayload = () => ({
  carbonCertList: [],
  carbonReportList: [],
  factoryList: [],
  supplyChainList: [],
  productList: [],
  otherList: [],
  dataType: PRODUCT_CARBON_REPORT_MASK,
  contactName: '',
  contactPhone: '',
});

/** 将「获取碳足迹详情」接口返回的 data 与默认空结构合并，避免缺字段把表单写成 undefined */
const normalizeDraftPayloadFromApi = (data) => {
  const empty = getEmptyInitPayload();
  if (!data || typeof data !== 'object') {
    return empty;
  }
  return {
    carbonCertList: Array.isArray(data.carbonCertList)
      ? data.carbonCertList
      : empty.carbonCertList,
    carbonReportList: Array.isArray(data.carbonReportList)
      ? data.carbonReportList
      : empty.carbonReportList,
    factoryList: Array.isArray(data.factoryList)
      ? data.factoryList
      : empty.factoryList,
    supplyChainList: Array.isArray(data.supplyChainList)
      ? data.supplyChainList
      : empty.supplyChainList,
    productList: Array.isArray(data.productList)
      ? data.productList
      : empty.productList,
    otherList: Array.isArray(data.otherList) ? data.otherList : empty.otherList,
    dataType:
      data.dataType !== undefined && data.dataType !== null
        ? Number(data.dataType)
        : empty.dataType,
    contactName:
      data.contactName !== undefined && data.contactName !== null
        ? data.contactName
        : empty.contactName,
    contactPhone:
      data.contactPhone !== undefined && data.contactPhone !== null
        ? data.contactPhone
        : empty.contactPhone,
  };
};

/** 与项目内其它接口一致，兼容 code 为字符串或数字 */
const isGreenApiSuccess = (res) => res != null && String(res.code) === '200';

const GREEN_CARBON_REPORT_URL = 'greenCarbonReport';

/** 列表单条详情 → 产品碳足迹组件 report 回显 */
const normalizeListRecordToReportList = (data) => {
  if (!data || typeof data !== 'object') {
    return [];
  }
  if (Array.isArray(data.carbonReportList) && data.carbonReportList.length > 0) {
    return data.carbonReportList;
  }
  return [data];
};

export default {
  components: {
    CarbonfootprintWapper,
    ProductCarbonFootprint,
    Tip,
    EDialog,
    CarbonFootprintAgreeDialog,
  },
  data() {
    return {
      submitVisible: false,
      ruleForm: {
        isAgree: false,
      },
      rules: {
        isAgree: [
          {
            validator: (rule, value, callback) => {
              if (value === '' || !value) {
                callback(
                  new Error('请阅读并同意《绿色低碳信息提供告知同意书》')
                );
              } else {
                callback();
              }
            },
            require: true,
            message: '请阅读并同意《绿色低碳信息提供告知同意书》',
            trigger: 'change',
          },
        ],
      },
      agreeVisible: false,
      draftReloadKey: 0,
      carbonReportList: [],
      carbonFootprintId: '',
      /** 列表页编辑/查看时的记录主键 */
      listRecordId: '',
      checkList: [PRODUCT_CARBON_REPORT_MASK],
      checkListItemList: [
        {
          id: 'productCarbonFootprint',
          label: '产品碳足迹',
          value: PRODUCT_CARBON_REPORT_MASK,
          key: 'carbonReportList',
          ref: 'productCarbonFootprint',
        },
      ],
      activeIndex: 'productCarbonFootprint',
      contactForm: {
        contactName: '',
        // 填报信息联系电话
        contactPhone: '',
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.USERINFO;
    },
    /** 直接依赖 store，避免 watch「计算属性嵌套字段」在部分场景下不触发导致未请求详情接口 */
    carbonDraftSupplierCode() {
      const info = this.$store.state.USERINFO;
      if (!info || info.companyId == null || info.companyId === '') {
        return '';
      }
      return info.companyId;
    },
    pageType() {
      return this.$route.query.type || 'add';
    },
    isReadonly() {
      return this.pageType === 'detail';
    },
    /** 列表行编辑：走 greenCarbonReport/update，不走草稿接口 */
    isListRecordEdit() {
      return this.pageType === 'edit' && !!this.listRecordId;
    },
    showSubmitBtn() {
      return this.pageType !== 'detail' && !this.isListRecordEdit;
    },
  },
  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler() {
        this.listRecordId =
          this.$route.query.id != null && String(this.$route.query.id).trim() !== ''
            ? String(this.$route.query.id)
            : '';
        this.getInitData();
      },
    },
  },
  methods: {
    handleChangeCheckList(value) {
      if (value.length === 0) {
        this.checkListItemList = [];
        this.activeIndex = '';
        return;
      }
      this.checkListItemList = this.options.filter((item) =>
        value.includes(item.value)
      );
      if (this.checkListItemList.length === 1) {
        this.activeIndex = this.checkListItemList[0].id;
        return;
      }
      if (
        !this.checkListItemList.find((item) => item.id === this.activeIndex)
      ) {
        this.activeIndex = this.checkListItemList[0].id;
      }
    },
    handleTab() {},
    // handleChange(list) {
    //   this[list] = [];
    // },
    applyInitPayload(payload) {
      /** 产品碳足迹：接口 carbonReportList 传给子组件回显（与 normalizeFromUnifiedApiRow 一致） */
      this.carbonReportList = Array.isArray(payload.carbonReportList)
        ? payload.carbonReportList
        : [];
      const dt =
        payload.dataType !== undefined && payload.dataType !== null
          ? Number(payload.dataType)
          : PRODUCT_CARBON_REPORT_MASK;
      this.checkList = normalizeMergedProductDataTypes(decodeMask(dt));
      if (this.checkList.length === 0) {
        this.checkList = normalizeMergedProductDataTypes(
          decodeMask(PRODUCT_CARBON_REPORT_MASK)
        );
      }

      this.contactForm = {
        contactName: payload.contactName || '',
        contactPhone: payload.contactPhone || '',
      };
      this.draftReloadKey += 1;
      this.activeIndex = 'productCarbonFootprint';
    },
    async getInitData() {
      const applyEmpty = () => {
        this.applyInitPayload(getEmptyInitPayload());
      };

      if (this.listRecordId) {
        try {
          const res = await api.detail({ id: this.listRecordId }, GREEN_CARBON_REPORT_URL);
          if (isGreenApiSuccess(res) && res.data) {
            const row = res.data;
            this.listRecordId = row.id != null ? String(row.id) : this.listRecordId;
            this.carbonFootprintId = row.carbonFootprintId || '';
            this.carbonReportList = normalizeListRecordToReportList(row);
            this.contactForm = {
              contactName: row.contactName || '',
              contactPhone: row.contactPhone || '',
            };
            this.draftReloadKey += 1;
            return;
          }
        } catch (e) {
          this.$message.error('获取详情失败，请稍后重试');
        }
        applyEmpty();
        return;
      }

      const supplierCode = this.carbonDraftSupplierCode;
      if (!supplierCode) {
        applyEmpty();
        return;
      }
      try {
        const res = await api.getGreenCarbonFootprintDetail({ supplierCode });
        if (isGreenApiSuccess(res)) {
          this.applyInitPayload(normalizeDraftPayloadFromApi(res.data));
        } else {
          applyEmpty();
        }
      } catch (e) {
        applyEmpty();
      }
    },
    handleClose() {
      this.$router.push('/CarbonfootprintManage/Carbonfootprint');
    },
    async getData() {
      const tasks = [];

      const that = this;
      this.checkListItemList.forEach((item) => {
        const tabVm = resolveTabRef(that.$refs, item.ref);
        if (!tabVm || typeof tabVm.submit !== 'function') {
          tasks.push(
            Promise.resolve({
              id: item.id,
              key: item.key,
              success: false,
            })
          );
          return;
        }
        tasks.push(
          tabVm
            .submit()
            .then((res) => ({
              id: item.id,
              key: item.key,
              ...res,
            }))
            .catch(() => ({
              id: item.id,
              key: item.key,
              success: false,
            }))
        );
      });

      const results = await Promise.all(tasks);
      const submitData = {};

      const tabsSubmit = [];

      results.forEach(({ id, success, data }) => {
        if (success) {
          if (id === 'productCarbonFootprint' && data && data.carbonReportList) {
            submitData.carbonReportList = data.carbonReportList;
          } else if (data) {
            Object.assign(submitData, data);
          }
        } else {
          // this.$message.error(`${key}校验不通过`);
          tabsSubmit.push(id);
        }
      });
      if (
        tabsSubmit.length > 0 &&
        tabsSubmit.indexOf(this.activeIndex) === -1
      ) {
        const [firstTab] = tabsSubmit;
        this.activeIndex = firstTab;
      }

      return tabsSubmit.length === 0 ? submitData : null;
    },
    async getSaveData() {
      const submitData = {};
      const that = this;
      await Promise.all(
        this.checkListItemList.map(async (item) => {
          const tabVm = resolveTabRef(that.$refs, item.ref);
          if (!tabVm || typeof tabVm.save !== 'function') {
            return;
          }
          const saved = await Promise.resolve(tabVm.save());
          if (!saved) {
            return;
          }
          if (item.id === 'productCarbonFootprint' && saved.carbonReportList) {
            submitData.carbonReportList = saved.carbonReportList;
          } else if (item.key) {
            submitData[item.key] = saved;
          }
        })
      );
      return submitData;
    },
    async handleSave() {
      if (this.checkList.length === 0) {
        this.$message.error('请选择上传类型');
        return;
      }
      // const carbonCertList =
      //   (this.$refs.carbonfootprintCertificate &&
      //     this.$refs.carbonfootprintCertificate[0].save()) ||
      //   [];
      // const carbonReportList =
      //   (this.$refs.carbonfootprintReport &&
      //     this.$refs.carbonfootprintReport[0].save()) ||
      //   [];

      // const factoryList =
      //   (this.$refs.greeFactoryEvalution &&
      //     this.$refs.greeFactoryEvalution[0].save()) ||
      //   [];
      // const supplyChainList =
      //   (this.$refs.supplyChain && this.$refs.supplyChain[0].save()) || [];
      // const productList =
      //   (this.$refs.productList && this.$refs.productList[0].save()) || [];
      // const otherList = (this.$refs.other && this.$refs.other[0].save()) || [];
      try {
        const submitData = await this.getSaveData();
        if (this.isListRecordEdit) {
          await this.submitListRecordUpdate(submitData);
          return;
        }
        this.submitDataFn(
          {
            ...submitData,
          },
          0
        );
      } catch (err) {
        if (err && err.message === 'validation') {
          return;
        }
        this.$message.error('保存失败，请稍后重试');
      }
      // const submitData = await this.getData();
      // this.submitDataFn(
      //   submitData,
      //   0,
      //   '/CarbonfootprintManage/Carbonfootprint'
      // );
      // console.log(submitData);
    },
    /** 列表页单条编辑保存（与旧 itemEdit + greenCarbonReport/update 一致） */
    async submitListRecordUpdate(submitData) {
      const rows = submitData.carbonReportList || [];
      const primary = rows[0] || {};
      const body = {
        id: this.listRecordId,
        ...primary,
      };
      if (rows.length > 1) {
        body.carbonReportChildrenList = rows.slice(1);
      }
      try {
        const res = await api.update(body, GREEN_CARBON_REPORT_URL);
        if (isGreenApiSuccess(res)) {
          this.$message.success('保存成功');
        }
      } catch (e) {
        this.$message.error('保存失败，请稍后重试');
      }
    },
    submitDataFn(submitData, staus, callbackUrl) {
      const submitType = {
        0: 'draft',
        1: 'submit',
      };
      let dataType = this.checkList.reduce((acc, item) => acc + item, 0);
      if (this.checkList.includes(PRODUCT_CARBON_REPORT_MASK)) {
        /* eslint-disable-next-line no-bitwise -- 与后端示例一致：含证书位 */
        dataType |= LEGACY_CERT_MASK;
      }
      const requestBody = {
        supplierCode: this.userInfo.companyId,
        dataType,

        ...submitData,
        ...this.contactForm,
      };
      api[submitType[staus]](requestBody).then((res) => {
        const { code } = res;
        if (code === '200') {
          this.$message.success(staus === 0 ? '已保存' : '操作成功！');
          if (callbackUrl) {
            this.$router.push(callbackUrl);
          }
        }
      });
    },
    async handleSubmit() {
      const submitData = await this.getData();
      if (submitData) {
        this.submitVisible = true;
        return;
      }
      const pcf = resolveTabRef(this.$refs, 'productCarbonFootprint');
      if (pcf && typeof pcf.showSubmitValidationTip === 'function') {
        await pcf.showSubmitValidationTip();
      }
    },
    async handleSubmitData() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const submitData = await this.getData();
          this.submitDataFn(
            submitData,
            1,
            '/CarbonfootprintManage/Carbonfootprint'
          );
          console.log(submitData);
        }
      });
    },
    resetPopupData() {
      this.submitVisible = false;
    },

    toAgreement() {
      this.agreeVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.supplier-info {
  width: 100%;

  .supplier-info-item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    .supplier-info-item-label {
      width: 130px;
      text-align: right;
      color: #666;
    }
    .supplier-info-item-value {
      // width: 450px;
      color: #333;
    }
  }
}
.required {
  color: #f0250f;
}
.footer-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  padding: 20px 80px;
  ::v-deep button {
    white-space: nowrap;
  }
}
.agreeTxt {
  margin-left: 10px;
}

.contactUs {
  width: 100%;
  height: 100px;
  margin: 0 auto;

  background-size: 1200px 100px;
  margin-bottom: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
  .left {
    width: 330px;
    height: 100px;
    background: url('../../../../assets/img/carbonfootprint/contactUsLeft.png')
      no-repeat center center;
    background-size: 100% 100%;
  }
  .right {
    width: 220px;
    height: 100px;
    background: url('../../../../assets/img/carbonfootprint/contactUsRight.png')
      no-repeat center center;
    background-size: 100% 100%;
  }
  .center {
    background: rgba(37, 135, 255, 0.1);
    display: flex;
    flex: 1;
    justify-content: flex-start;
    padding-left: 140px;
    align-items: center;
    height: 100px;
    gap: 100px;
  }
  // gap: 100px;
  // padding-left: 464px;
  .item {
    display: flex;
    gap: 16px;
  }
  .name {
    font-size: 18px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    // margin-right: 10px;
    line-height: 1;
  }
  .phone {
    font-size: 16px;
    // font-family: PingFangSC-Medium;
    // font-weight: 500;
    // margin-right: 30px;
    line-height: 1;
  }
  .email {
    font-size: 16px;
    // font-family: PingFangSC-Medium;
    // font-weight: 500;
  }
  .itemIcon {
    margin-right: 5px;
  }
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  background: #fff;
  border-bottom: 1px solid rgba(217, 217, 217, 1) !important;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-top: 2px #2587ff solid !important;
  background: #f4f7ff !important;
  line-height: 48px;
  color: #2587ff !important;
}

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__nav-wrap.is-scrollable {
  padding: 0;
}

::v-deep .el-tabs__item {
  border-top: 2px #fff solid;
  line-height: 48px;
  height: 48px;
  color: #333333 !important;
}
.tabs-container {
  margin-top: 20px;
}
.tabs-wapper {
  background: #fff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-top: none;
  padding: 20px;
}

::v-deep.el-form-item {
  .el-form-item__label {
    padding: 0px;
    padding-right: 10px;
    color: #666;
  }
  .el-form-item__label:after {
    content: '';
    display: none;
  }
}

::v-deep.el-form-item.cursor-form-item {
  .el-form-item__label {
    /* line-height: 1; */
  }
}

::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '*';
  color: rgba(240, 37, 15, 1);
  margin-right: 0px !important;
  /* margin-right: 4px; */
}
::v-deep.el-form .el-input__inner,
::v-deep.el-form .el-input,
::v-deep.el-form .el-date-editor,
::v-deep.el-form .el-select .el-input__inner,
::v-deep.el-form .el-select .el-input__inner,
::v-deep.el-input--small .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
::v-deep.el-radio {
  margin-right: 0px;
}
::v-deep.remark {
  padding-left: 0px !important;
}
::v-deep.el-radio__label {
  color: #333;
}
::v-deep.el-radio__input.is-checked + .el-radio__label {
  color: #333;
}
</style>
